
new WOW({
  mobile: false,
  live: false
}).init();

console.log("WOW.JS initialized.");


$('.sev-faq-item-toggle').click(function(e){
  e.preventDefault();
  $(this).find('.sev-faq-item-title-arrow span').toggleClass("icon--arrow-top icon--arrow-down");
  var collapse_content_selector = $(this).attr('href');	
  $(collapse_content_selector).fadeToggle();
});


// AGB Checkbox
/*
$(document).ready(function() {
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("You must agree with the terms and conditions of sales to check out.");
      return false;
    }
  });
});
*/


/*
$('.sev-series-dropdown-slider').flickity({
  // options
  cellAlign: 'left',
  contain: false
});
*/

//$(document).ready(function () {
    //$("button#sev-series-dropdown-toggle").click(function (e) {
      
      //$('.sev-series-dropdown-container').slideToggle("fast");
  
      /*
      if ($('.sev-series-dropdown-container').is(":visible")) {
        $('.sev-series-dropdown-container').hide("fast", "swing");
        //$(this).attr("src", "Image/up-arrow.jpg");
      } else {
        $('.sev-series-dropdown-container').show("fast", "swing");
        //$(this).attr("src", "Image/down-arrow.jpg");
      }
      */
      
    //});
//  });